import type React from 'react';

import { Box, FormField, FormHelp, Label, Paragraph, Textarea } from '@zillow/constellation-10';
import { LeaseStatus } from '@zg-rentals/rental-manager-env';

import type { Lease } from '../../../../models';
import WhoHasSigned from '../../../Widgets/WhoHasSigned';
import { FULLSTORY_EXCLUDE } from '../../../../constants/analytics';

type OwnProps = {
  cancellationReason: string;
  lease: Lease;
  onCancellationReasonChange(event: React.FormEvent<HTMLTextAreaElement>): void;
};

export default function CancellationPrompt({
  cancellationReason,
  lease,
  onCancellationReasonChange,
}: OwnProps): JSX.Element {
  const isOfflineSigning = lease.status === LeaseStatus.SENT_FOR_OFFLINE_SIGNING;

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'tight' }}>
      {!isOfflineSigning && (
        <Paragraph>
          When you cancel signing, all signatures will be removed. After you update the lease you can request signatures
          again.
        </Paragraph>
      )}
      {lease.showWhoHasSigned() && (
        <Box>
          <WhoHasSigned isInitiallyExpanded leaseId={lease.id} />
        </Box>
      )}
      <FormField
        className={FULLSTORY_EXCLUDE}
        required
        label={<Label aria-label="cancellation reason">Cancellation reason</Label>}
        control={
          <Textarea
            aria-labelledby="cancellation reason"
            css={{ resize: 'vertical' }}
            value={cancellationReason}
            onChange={onCancellationReasonChange}
          />
        }
        description={<FormHelp>This will be sent to all your tenants</FormHelp>}
      />
    </Box>
  );
}
